import React from "react";
import banner from "../assets/new-images/banner/banner.webp";
import banner_1 from "../assets/new-images/banner/banner_1.webp";
import banner_2 from "../assets/new-images/banner/banner_2.webp";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, EffectFade } from "swiper/modules";

// Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

function Banner() {
  return (
    <div className="banner-visual">
      <div className="banner-img">
        <div className="img-wrapper">
          <Swiper
            modules={[Navigation, Autoplay, EffectFade]}
            slidesPerView={1}
            loop={true}
            navigation={true}
            effect="fade"
            speed={900}
            autoplay={{
              delay: 3500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
          >
            {/* Slide 1 */}
            <SwiperSlide>
              <img src={banner} alt="Employee transportation" />
              <div className="banner-trust-badges">
                <span className="banner-badge">Verified Drivers</span>
                <span className="banner-badge">On-Time Pickup</span>
                <span className="banner-badge">24/7 Support</span>
              </div>
            </SwiperSlide>

            {/* Slide 2 */}
            <SwiperSlide>
              <img src={banner_1} alt="Employee transportation" />
              <div className="banner-trust-badges">
                <span className="banner-badge">Clean Vehicles</span>
                <span className="banner-badge">Professional Drivers</span>
                <span className="banner-badge">Safe & Reliable</span>
              </div>
            </SwiperSlide>

            {/* Slide 3 */}
            <SwiperSlide>
              <img src={banner_2} alt="Employee transportation" />
              <div className="banner-trust-badges">
                <span className="banner-badge">Corporate Trusted</span>
                <span className="banner-badge">Comfortable Rides</span>
                <span className="banner-badge">Affordable Pricing</span>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  );
}

export default Banner;
